import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('mousedown', this.startResize)
  }

  startResize = (e) => {
    document.addEventListener('mousemove', this.resize)
    document.addEventListener('mouseup', this.stopResize)
    this.resizeStartX = e.clientX
    this.dispatch('startResize')
  }

  resize = (e) => {
    // Recover from a missed mouseup: if the button was released outside the window
    // (no `mouseup` fires on the document), the next in-window mousemove arrives with
    // no buttons pressed. End the resize then so we don't keep resizing / leak the
    // listeners (and so consumers relying on stopResize aren't left mid-drag).
    if (e.buttons === 0) {
      this.stopResize(e)
      return
    }

    const dx = e.clientX - this.resizeStartX
    this.dispatch('resize', { detail: { dx } })
  }

  stopResize = (e) => {
    document.removeEventListener('mousemove', this.resize)
    document.removeEventListener('mouseup', this.stopResize)
    this.resizeStartX = null
    this.dispatch('stopResize')
  }

  disconnect() {
    this.element.removeEventListener('mousedown', this.startResize)
  }
}
